const mixin = {
  computed: {
    frameOptionName() {
      if (this.item.frame.option == null) return ""

      const options = this.item.frame.option.split(".")
      const stretching = options.includes("stretching")

      return `${stretching ? "stretching" : "framing"}`
    },
  },
}

export default mixin
